import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { tap } from 'rxjs/operators';
import { UserPrefs, RequestStatus, NGXLogger } from '@app/shared';
import { UserService, PermissionsService, MessagingService } from '@app/core';
import {
  AuthActionTypes,
  LogIn,
  LogInSuccess,
  LogInFailure,
  LogOut,
  LogOutSuccess,
  LogOutFailure,
  SetUserPrefs,
  SetUserPrefsSuccess,
  GetUser,
  GetUserSuccess,
  GetUserFailure,
  UpdateUser,
  UpdateUserSuccess,
  UpdateUserFailure,
  GetUserDash,
  GetUserDashSuccess,
  GetUserDashFailure,
  SSO,
  SSOSuccess,
  SSOFailure,
} from '../actions/auth.actions';

@Injectable()
export class AuthEffects {

  constructor(
    private actions: Actions,
    private userService: UserService,
    private router: Router,
    private workflow: PermissionsService,
    private logger: NGXLogger,
    private msgService : MessagingService,
  ) {}

  // effects go here
  @Effect()
  LogIn: Observable<any> = this.actions
    .ofType(AuthActionTypes.LOGIN)
    .map((action: LogIn) => action.payload)
    .switchMap(payload => {
      return this.userService.auth(payload.email, payload.password)
        .map((user) => {
          this.logger.debug(user);
          //return new LogInSuccess({token: user.token, email: payload.email});
          // get user token Prefs
          let dep = user.departments.replace(/[\[\]']+/g,'');
          let tmpDep = dep.split(',');
          let departments = [];

          if(user.departments && user.departments.length){
            for(dep of tmpDep){
              dep = dep.replace(/^\s+|\s+$/g,'');
              if(dep.length)
                departments.push(dep);
            }
          }

          user.uuid = user.id;
          user.departments = departments;

          //user.departments.map(dep => dep.replace(/^\s+|\s+$/g,''))
          let prefs = localStorage.getItem('prefs')?JSON.parse(localStorage.getItem('prefs')):new UserPrefs();
          // turn the departments into an Array

          return new LogInSuccess({user:user, prefs:prefs});
        })

        .catch((error) => {
          this.logger.debug(error);
          return Observable.of(new LogInFailure({ error: error }));
        });
    });

    @Effect({ dispatch: false })
    LogInSuccess: Observable<any> = this.actions.pipe(
      ofType(AuthActionTypes.LOGIN_SUCCESS),
      tap((action) => {
        // set user roles in the permission service
        // TODO temp
        // let roles = ["PMOPERATIONS_EDIT"]
        // action.payload.user.roles = roles;
        this.workflow.setRoles(action.payload.user.roles);
        localStorage.setItem('user', JSON.stringify(action.payload.user));
        this.router.navigateByUrl('/main');
      })
    );
    @Effect({ dispatch: false })
    LogInFailure: Observable<any> = this.actions.pipe(
      ofType(AuthActionTypes.LOGIN_FAILURE)
    );

    // @Effect({ dispatch: false })
    // public LogOut: Observable<any> = this.actions.pipe(
    //   ofType(AuthActionTypes.LOGOUT),
    //   tap((user) => {
    //     this.router.navigateByUrl('/auth/login');
    //     localStorage.removeItem('user');
    //   })
    // );

    @Effect()
    LogOut: Observable<any> = this.actions
      .ofType(AuthActionTypes.LOGOUT)
      .map((action: LogIn) => action.payload)
      .switchMap(payload => {

        localStorage.removeItem('user');
        this.msgService.deleteToken(payload.user.fbToken).catch((err) => {
          // console.log('fail')
        });

        return this.userService.logout(payload.user)
          .map((user) => {
            this.logger.debug(user);
            //return new LogInSuccess({token: user.token, email: payload.email});
            // get user token Prefs

            return new LogOutSuccess({user:payload.user});
          })

          .catch((error) => {
            // console.log(error,'FAIL');
          //  return new LogOutSuccess({user:payload.user});
            //return Observable.of(new LogOutSuccess({user:payload.user}));
            return Observable.of(new LogOutFailure({ error: "Incorrect Username / Password" }));
          });
      });
    // LogOut: Observable<any> = this.actions
    //   .ofType(AuthActionTypes.LOGOUT)
    //   .map((action: LogOut) => action.payload)
    //   .switchMap(payload => {
    //     this.logger.debug('logout effect')
    //     //return new LogOutSuccess(payload)
    //     return Observable.of(new LogOutSuccess({}));
    //   })

    @Effect({ dispatch: false })
    LogOutSuccess: Observable<any> = this.actions.pipe(
      ofType(AuthActionTypes.LOGOUT_SUCCESS),
      tap((result) => {
        this.logger.info('logged out');
        // if(result.payload.user.fbToken){
        //   this.msgService.deleteToken(result.payload.user.fbToken).then(_ => {
        //     this.router.navigateByUrl('/auth/login');
        //   })
        // }else{
        this.router.navigateByUrl('/auth/login');
        //}
        localStorage.removeItem('user');
      })
    );
    @Effect({ dispatch: false })
    LogOutFailure: Observable<any> = this.actions.pipe(
      ofType(AuthActionTypes.LOGOUT_FAILURE)
    );


    @Effect()
    SetUserPrefs: Observable<any> = this.actions
      .ofType(AuthActionTypes.SET_USER_PREFS)
      .map((action: SetUserPrefs) => action.payload)
      .switchMap(payload => {
        return Observable.of(new SetUserPrefsSuccess({prefs:payload.prefs}));
      })

    @Effect({ dispatch: false })
    SetUserPrefsSuccess: Observable<any> = this.actions.pipe(
      ofType(AuthActionTypes.SET_USER_PREFS_SUCCESS),
      tap((result) => {
        this.logger.debug(result, 'setting prefs');
        let prefs = localStorage.getItem('prefs')?JSON.parse(localStorage.getItem('prefs')):new UserPrefs();
        Object.keys(result.payload.prefs).forEach(function (key) {

        //  if(prefs[key])
            prefs[key] =  result.payload.prefs[key];
        });
        this.logger.debug(prefs, 'new setting prefs');

        localStorage.setItem('prefs', JSON.stringify(prefs));
      })
    );


    @Effect()
    UpdateUser: Observable<any> = this.actions
      .ofType(AuthActionTypes.UPDATE_USER)
      .map((action: SetUserPrefs) => action.payload)
      .switchMap(payload => {
        return Observable.of(new UpdateUserSuccess({user:payload.user}));
      })

    @Effect({ dispatch: false })
    UpdateUserSuccess: Observable<any> = this.actions.pipe(
      ofType(AuthActionTypes.UPDATE_USER_SUCCESS),
      tap((result) => {
        this.logger.debug(result, 'updating user')
        localStorage.setItem('user', JSON.stringify(result.payload.user));
      })
    );



    @Effect()
    GetUser: Observable<any> = this.actions
      .ofType(AuthActionTypes.GET_USER)
      .map((action: GetUser) => action.payload)
      .switchMap(payload => {
        let user = localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):null;
        let prefs = localStorage.getItem('prefs')?JSON.parse(localStorage.getItem('prefs')):new UserPrefs();
        this.workflow.setRoles(user.roles);
        return Observable.of(new GetUserSuccess({user:user, prefs:prefs}));
      })

    @Effect({ dispatch: false })
    GetUserSuccess: Observable<any> = this.actions.pipe(
      ofType(AuthActionTypes.GET_USER_SUCCESS),
      tap((result) => {
        this.logger.debug(result, 'getting user from storage');
      })
    );


    @Effect()
    GetUserDash: Observable<any> = this.actions
        .ofType(AuthActionTypes.GET_USER_DASH)
        .debounceTime(10)
        .map((action: GetUserDash) => action.payload)
        .switchMap(payload => {
          return this.userService.getUserDash()
            .map((result) => {
              let rs : RequestStatus = new RequestStatus();
              //rs.code = result.code;
              rs.msg = `Job has been saved`;

              return new GetUserDashSuccess({dasboardData:result})
            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to load the dashboard."

              return Observable.of(new GetUserDashFailure({ errorStatus: rs }));
            });
        })

    @Effect({ dispatch: false })
    GetUserDashSuccess: Observable<any> = this.actions.pipe(
      ofType(AuthActionTypes.GET_USER_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetUserDashFailure: Observable<any> = this.actions.pipe(
      ofType(AuthActionTypes.GET_USER_DASH_FAILURE)
    );


    @Effect()
    SSO: Observable<any> = this.actions
        .ofType(AuthActionTypes.SSO)
        .map((action: SSO) => action.payload)
        .switchMap(payload => {
          return this.userService.sso2(payload)
            .map((user) => {

              this.logger.debug(user);
              //return new LogInSuccess({token: user.token, email: payload.email});
              // get user token Prefs
              let dep = user.departments.replace(/[\[\]']+/g,'');
              let tmpDep = dep.split(',');
              let departments = [];

              if(user.departments && user.departments.length){
                for(dep of tmpDep){
                  dep = dep.replace(/^\s+|\s+$/g,'');
                  if(dep.length)
                    departments.push(dep);
                }
              }

              user.uuid = user.id;
              user.departments = departments;

              //user.departments.map(dep => dep.replace(/^\s+|\s+$/g,''))
              let prefs = localStorage.getItem('prefs')?JSON.parse(localStorage.getItem('prefs')):new UserPrefs();
              // turn the departments into an Array

              return new SSOSuccess({user:user, prefs:prefs});
              // let rs : RequestStatus = new RequestStatus();
              // rs.code = result.code;
              // rs.msg = `Region has been saved`;

              // return new SSOSuccess({result})
            })
            .catch((error) => {
              this.logger.debug(error);
              // let rs : RequestStatus = new RequestStatus();
              // rs.code = error.status;
              // rs.msg = error.statusText;
              // rs.msg = "Sorry unable to save the Region."

              return Observable.of(new SSOFailure({ error }));
            });
        })

    @Effect({ dispatch: false })
    SSOSuccess: Observable<any> = this.actions.pipe(
      ofType(AuthActionTypes.SSO_SUCCESS),
      tap((action) => {
        // set user roles in the permission service
        // TODO temp
        // let roles = ["PMOPERATIONS_EDIT"]
        // action.payload.user.roles = roles;
        this.workflow.setRoles(action.payload.user.roles);
        localStorage.setItem('user', JSON.stringify(action.payload.user));
        this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    SSObFailure: Observable<any> = this.actions.pipe(
      ofType(AuthActionTypes.SSO_FAILURE)
    );


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/effects/auth.effects.ts